export var FETCH_BACKOFF_BASE = 10000; // backoff base starting at 10 seconds
export var FETCH_BACKOFF_MAX_WAIT = 60000; // don't wait for more than 1 minute
export var FETCH_BACKOFF_MAX_RETRIES = 10; // max retries



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/sync/streaming/UpdateWorkers/constants.js
// module id = 1983
// module chunks = 25